import React, { FunctionComponent } from 'react';
import { Route, Routes } from 'react-router-dom';
import EmailCampaignPageWrapper from '../../campaigns/email-campaign/email-campaign-wrapper-component';
import CRMEmailPageWrapper from '../../crm-email/crm-email-wrapper-component';
import DocumentPageWrapper from '../../document/document-page-wrapper-component';
import LifecycleEmailPageWrapper from '../../lifecycle-email/lifecycle-email-wrapper-component';
import { StyledRouter } from './styled-router-component';

export const BaseRouter: FunctionComponent = () => {
  return (
    <Routes>
      {/* START: Routes without any styling */}
      <Route path='content/user/viewinbrowser' element={<EmailCampaignPageWrapper />} />
      <Route path='content/user/lifecycleviewinbrowser' element={<LifecycleEmailPageWrapper />} />
      <Route path='content/user/viewemailsinbrowser' element={<CRMEmailPageWrapper />} />
      <Route path='content/document/:type/:stockCode' element={<DocumentPageWrapper />} />
      {/* END: Routes without any styling */}

      <Route path='*' element={<StyledRouter />}></Route>
    </Routes>
  );
};
